import { Button, Grid, IconButton } from "@mui/material";
import React from "react";
import TextFieldReadOnly from "../../UI/TextFieldReadOnly";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

const TextFieldUsuario = ({
  label,
  value,
  handleBuscarUsuario,
  handleDeleteUsuario,
}) => {
  return (
    <Grid container alignItems="center" direction="row" spacing={3}>
      <Grid size={3}>
        <TextFieldReadOnly
          label={label}
          size="small"
          placeholder={label}
          style={{ minWidth: "50%" }}
          value={value}
        />
      </Grid>
      <Grid>
        <IconButton onClick={handleDeleteUsuario} aria-label="search">
          <HighlightOffIcon fontSize="small" />
        </IconButton>
      </Grid>
      <Grid>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleBuscarUsuario}
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
};

export default TextFieldUsuario;
